import styled from 'styled-components'

export const Card = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  width: 340px;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 18px;
  border: 1px solid #d1d3d4;
  border-radius: 6px;
  cursor: pointer;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  &:hover {
    transform: scale(1.02);
    box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.2);
  }
`
export const Stack = styled.div<{
  alignItems: string
  justifyContent: string
  direction: string
  gap: string
}>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap};
  align-items: ${({ alignItems }) => alignItems};
  justify-content: ${({ justifyContent }) => justifyContent};
  flex-direction: ${({ direction }) => direction};
  width: 100%;
`
